module.exports = __webpack_public_path__ + "img/icon_directions2.17df5db7.png";